import PdwDownload from "Components/GMS/Pdw/PdwDownload";
import React from "react";
import Dialog from "Components/DesignSystem/Dialog/Dialog";
import Typography from "Components/DesignSystem/Typography/Typography";

/**
 * "Download Template" from the Products list. On DS `Dialog` since § 126.
 *
 * `instanceId` is passed explicitly even though this dialog and the `/gms/pdw`
 * Template dialog are never open together: it keeps the testids of the two entry
 * points distinguishable in a Playwright trace, which the shared default would not.
 */
const TemplatePDW = (props) => {
  /*
    Three states, not two — the legacy `categoriesList === null ? null : …` guard was
    load-bearing and is preserved:

      null  → still loading. Render NOTHING. Saying "No categories available to
              select" here would be a claim we cannot make yet, and the Products list
              can open this dialog before its fetch resolves.
      {}    → loaded, genuinely empty. Say so.
      {…}   → the picker.
  */
  const stillLoading = props.categoriesList === null || props.categoriesList === undefined;
  const hasCategories =
    props.categoriesList &&
    props.categoryTypeList &&
    Object.keys(props.categoriesList).length > 0;

  return (
    <Dialog
      isOpen={!!props.showPopup}
      onClose={props.modalClose}
      closeOnOutsideClick
      size="lg"
      title="Download Template"
      data-testid="pdw-products-template-dialog"
    >
      <div className="tw-mb-4">
        <Typography variant="body-primary" as="p" className="tw-text-ink-secondary">
          Choose any category to download blank product template
        </Typography>
      </div>
      {stillLoading ? null : hasCategories ? (
        <PdwDownload
          instanceId="pdw-products-template"
          categoriesList={props.categoriesList}
          categoryTypeList={props.categoryTypeList}
          modalClose={props.modalClose}
        />
      ) : (
        <Typography variant="body-primary" as="p" data-testid="pdw-products-template-empty">
          No categories available to select
        </Typography>
      )}
    </Dialog>
  );
};

export default TemplatePDW;
